import { Title } from '@angular/platform-browser';
import Globalize from 'globalize';
import { SettingsService } from './../../settings/settings.service';
import { ForecastError, ForecastAndActual, StockOut, ScenarioTableCalculetedFields, FutureForecastChartDto, LeadTimeChartDto, Production, EsoService, Product, ActualInventory, Scenario, DateStandard, FinancialSituationScenario, ScenarioFinancialsToBe, ProductWithScenarios } from '../eso.service';
import { Component, OnInit, QueryList, ViewChildren, ChangeDetectorRef, ViewChild, inject } from '@angular/core';
import DataSource, { Options } from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { ActivatedRoute, Data } from '@angular/router';
import { DxChartComponent, DxDataGridComponent } from 'devextreme-angular';
import { Task, TaskService } from '../../task/task.service';
import { Location } from '@angular/common';
import { MasterTableData } from 'src/app/models/forecast/fc-deepdive-models';
import { UtilsService } from 'src/app/services/utils.service';
import { GlobalConstants } from 'src/app/common/global-constants';
import { HelpService } from '../../help/help.service';
import { AutocompleteComponent, DevTooltipCustComponent } from 'src/app/widgets';
import { FileExportService } from 'src/app/common/file-export-service';
import { BookmarkData } from 'src/app/models/Bookmark';
import { ShareDataService } from 'src/app/services/share-data.service';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { DxSelectBoxTypes } from 'devextreme-angular/ui/select-box';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';
import { BookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/bookmark-elements.operator';
import { DxDataGridBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-data-grid-bookmark-elements.operator';
import { DxChartBookmarkElementsOperator } from 'src/app/widgets/bookmark-new/operators/elements-operators/dx-chart-bookmark-elements.operator';
import { firstValueFrom, Subscription } from 'rxjs';

@Component({
	selector: 'app-deep-dive',
	templateUrl: './deep-dive.component.html',
	styleUrls: ['./deep-dive.component.scss'],
	standalone: false
})
export class DeepDiveComponent implements OnInit {

	@ViewChildren(DxChartComponent) chartComponents: QueryList<DxChartComponent>;

	//New Bookmark
	@ViewChild('bookmarksGroup', { static: false })
	public bookmarksGroup: BookmarkNewComponent;

	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);

	public bookmarkElementsOperators: BookmarkElementsOperator[];

	// Task data
	tasks: Task[] = [];
	showTasksPopup = false;
	showAddTaskPopup = false;

	activeTasksForCurrentPage = false;
	activeTasks: Task[] = [];

	public showInfoPopup = false;
	public infoPopupMessage = "";
	ImageInfoPopup: boolean;

	//ProductImage
	ProductImageHeight: any;
	ProductImagePath: any;
	ProductImageWidth: any;
	imgSrc: string;
	ImgTitle: string;

	//? GOOD.
	private hideInfoPopupWithDelay(delay: number = 4000) {
		const $this = this;
		setTimeout(
			() => {
				$this.showInfoPopup = false;
				$this.changeDetectorRef.detectChanges();
			},
			delay
		);
	}

	//Auto Complete Variables
	public productsAutocompleteDataSource: string[] = [];

	@ViewChild('autocomplete') autocomplete: AutocompleteComponent;
	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;

	@ViewChild("ActualSalesVsForecast", { static: false }) dxActualSalesVsForecast: DxChartComponent;
	@ViewChild("ForecastError", { static: false }) dxForecastError: DxChartComponent;
	@ViewChild("ActualInventory", { static: false }) dxActualInventory: DxChartComponent;
	@ViewChild("FutureForecast", { static: false }) dxFutureForecast: DxChartComponent;
	@ViewChild("SimulatedInventory", { static: false }) dxSimulatedInventory: DxChartComponent;
	@ViewChild("LeadTime", { static: false }) dxLeadTime: DxChartComponent;

	//Grid Variables
	productsDataSource: CustomStore;
	productionData: Production[];
	public selectedProduct: Product = new Product();
	scenarioTableCalculetedFields = new ScenarioTableCalculetedFields();

	private _restrictSecondScenarioChartUpdate: boolean;

	gridColumns: { columnName: string; caption: string; dataType: string }[] = [];
	gridData: {
		IsDirty: boolean;
		ProductId: string;
		[key: string]: string | number | boolean;
	}[] = [];

	currentProductWithScenarios: ProductWithScenarios;

	//Charts Variables
	// chartsDataSource: any = {};
	actualInventoryDataSource: ActualInventory[] = [];
	forecastErrorDataSourse: ForecastError[] = [];
	forecastAndActualDataSource: ForecastAndActual[] = [];
	stockOutDataSourse: StockOut[] = [];
	visualRange: any = {};
	futureForecastChartDatasource: FutureForecastChartDto[] = [];
	leadTimeChartDatasource: LeadTimeChartDto[] = [];
	masterTableDataSource: MasterTableData[];


	//Scenario Variables
	scenarios: Scenario[] = [];
	selectedFirstScenario = new Scenario();
	selectedFirstScenarioName = "";
	selectedSecondScenario = new Scenario()
	selectedSecondScenarioName = "";
	scenariosDropdownOptions = [];
	scenariosSecondDropdownOptions: any;

	currentBaseScenarioName: string = null;

	allProducts: Product[] = [];

	sequenceErrorsList: string[] = [];

	showAssumptionsAdditionalData = false;
	showInventoryAdditionalData = false;
	showStockOutAdditionalData = false;
	showScrapAdditionalData = false;
	showProdChangeCost = false;

	productionLegendChartCaption = "";
	salesLegendChartCaption = "";
	inventoryOpenningLegendChartCaption = "Inventory Openning";
	invAdjustmentsLegendChartCaption = "InvAdjustments";

	valuesFormat: any = {
		label: {
			format: {
				type: "fixedPoint",
				precision: 0,
			},
		},
	};

	argumentAxis: any = {
		label: {
			format: {
				type: "fixedPoint",
				precision: 0,
			},
		},
	};

	actualSource = '';
	forecastSource = '';
	leadTime = '';
	SecondHeaderName = '';
	firstWeek: Date | number | string;
	lastWeek: Date | number | string;
	firstWeekForecast: Date | number | string;
	lastWeekForecast: Date | number | string;
	firstWeekStr: any;
	lastWeekStr: any;
	firstWeekForecastStr: any;
	lastWeekForecastStr: any;
	periodType: string;
	yearWeeks: DateStandard[];

	errorConcatPeriod: string;
	fcConcatPeriod: string;


	focusedRowKey = 0;
	autoNavigateToFocusedRow = true;

	public locale: any = "en";

	private readonly captions: Map<string, string> = new Map<string, string>([
		["ActualSource-Raw", "Actual"],
		["ActualSource-Clean", "ActualClean"],
		["ActualSource-Clean2", "ActualClean"],
		["ForecastSource-Raw", "Forecast"],
		["ForecastSource-Clean", "ForecastClean"],
		["ForecastSource-Clean2", "ForecastClean"],
	]);

	private readonly _componentTitle = "Eso Deep Dive";
	private readonly _productIdQueryParamName = "productId";

	constructor(
		private esoServise: EsoService,
		private route: ActivatedRoute,
		private taskService: TaskService,
		private location: Location,
		private settingsService: SettingsService,
		private esoService: EsoService, private shareDataService: ShareDataService,
		private helpService: HelpService,
		private titleService: Title,
		private changeDetectorRef: ChangeDetectorRef, private fileExportService: FileExportService
	) {
	}

	public async initializeBookmarks(): Promise<Data> {
		let routeData: Data = await firstValueFrom(this._activatedRoute.data);

		const operators = [
			this.dataGrid ? new DxDataGridBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxDataGridBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.dataGrid
			) : null,
			this.dxActualSalesVsForecast ? new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART).toString(),
				() => this.dxActualSalesVsForecast
			) : null,
			this.dxForecastError ? new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART + 1).toString(),
				() => this.dxForecastError
			) : null,
			this.dxActualInventory ? new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART + 2).toString(),
				() => this.dxActualInventory
			) : null,
			this.dxFutureForecast ? new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART + 3).toString(),
				() => this.dxFutureForecast
			) : null,
			this.dxSimulatedInventory ? new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART + 4).toString(),
				() => this.dxSimulatedInventory
			) : null,
			this.dxLeadTime ? new DxChartBookmarkElementsOperator(
				UtilsService.computeRouteHash(routeData.id, DxChartBookmarkElementsOperator.DEFAULT_ID_PART + 5).toString(),
				() => this.dxLeadTime
			) : null
		].filter(operator => operator !== null); // Remove null entries

		this.bookmarkElementsOperators = operators;

		return routeData;
	}

	ngOnInit() {
		this.titleService.setTitle(this._componentTitle);
		this.locale = Globalize.locale().locale;

		setTimeout(() => {
			this.initializeBookmarks();
		}, 500);

		// this.initializePeriodsAndSimulationData();
		this.initializeAllSettings();
		//auto complete data
		this.initializeAutocompleteData();

		this.initializeGridData();
	}

	private initializeAutocompleteData() {
		let productId = null;
		if (this.route.snapshot.queryParamMap.get(this._productIdQueryParamName)) {
			productId = this.route.snapshot.queryParamMap.get(this._productIdQueryParamName);
		}
		else if (this.route.snapshot.queryParamMap.get("id")) {
			productId = this.route.snapshot.queryParamMap.get("id");
		}

		if (productId && productId.toLowerCase() != 'null' && productId.toLowerCase() != 'undefined') {
			this.selectProduct(productId);

		} else {
			this.esoService.SelectFirstEsoObject().subscribe((resp) => {
				this.selectProduct(resp[0]);
			});
		}

		this.esoService.getAutocompleteData().subscribe(
			(response) => {
				this.allProducts = [];
				for (let a = 0; a < response.length; a++) {
					this.allProducts.push(Object.assign(new Product(), { code: response[a] }));
				}
				this.initializeAutocompleteList();
			},
			(error) => {

				this.notificationError(error);
			}
		);
	}


	//TODO: Consider simplifying this. It fetches again most of the data but then it searches through it. Consider having a direct request with concrete return values and strong type.
	//? GOOD.
	private initializePeriodsAndSimulationData() {
		try {
			if (this.periodType !== 'Week') {
				let year = this.SimulateDetails.find(x => x.name === 'First Period').value.substr(0, 4);
				let date = this.GetDateFromWeekNumber(parseInt(this.SimulateDetails.find(x => x.name === 'First Period').value.slice(-2)), parseInt(year));
				this.firstWeek = date;

				year = this.SimulateDetails.find(x => x.name === 'Last Period').value.substr(0, 4);
				date = this.GetDateFromWeekNumber(parseInt(this.SimulateDetails.find(x => x.name === 'Last Period').value.slice(-2)), parseInt(year));
				this.lastWeek = date;

				year = this.SimulateDetails.find(x => x.name === 'First Period Forecast').value.substr(0, 4);
				date = this.GetDateFromWeekNumber(parseInt(this.SimulateDetails.find(x => x.name === 'First Period Forecast').value.slice(-2)), parseInt(year));
				this.firstWeekForecast = date;

				year = this.SimulateDetails.find(x => x.name === 'LastWeekIdForecast').value.substr(0, 4);
				date = this.GetDateFromWeekNumber(parseInt(this.SimulateDetails.find(x => x.name === 'LastWeekIdForecast').value.slice(-2)), parseInt(year));
				this.lastWeekForecast = date;
			} else {
				this.firstWeekStr = this.yearWeeks.find(x => x.yearWeek === this.SimulateDetails.find(x => x.name === 'First Period').value);
				this.lastWeekStr = this.yearWeeks.find(x => x.yearWeek === this.SimulateDetails.find(x => x.name === 'Last Period').value);
				this.firstWeekForecastStr = this.yearWeeks.find(x => x.yearWeek === this.SimulateDetails.find(x => x.name === 'First Period Forecast').value);
				this.lastWeekForecastStr = this.yearWeeks.find(x => x.yearWeek === this.SimulateDetails.find(x => x.name === 'LastWeekIdForecast').value);
			}

			this.errorConcatPeriod = this.firstWeekStr.yearWeek + "-" + this.lastWeekStr.yearWeek;
			this.fcConcatPeriod = this.firstWeekForecastStr.yearWeek + "-" + this.lastWeekForecastStr.yearWeek;

			this.actualSource = this.captions.get("ActualSource-" + this.SimulateDetails.find((x) => x.name === "ActualSource").value);
			this.forecastSource = this.captions.get("ForecastSource-" + this.SimulateDetails.find((x) => x.name === "ForecastSource").value);
			this.leadTime = this.SimulateDetails.find((x) => x.name === "LeadTime").value;
		} catch (error) { }
	}

	//TODO: Move to utilities.
	private GetDateFromWeekNumber(w, y) {
		const exactDate = new Date(y, 0, 1 + (w - 1) * 7);
		const dow = exactDate.getDay();
		const isoWeekStart = exactDate;

		if (dow <= 4) {
			isoWeekStart.setDate(exactDate.getDate() - exactDate.getDay() + 1);
		} else {
			isoWeekStart.setDate(exactDate.getDate() + 8 - exactDate.getDay());
		}

		return isoWeekStart;
	}

	//? GOOD.
	public getMarkerPath(item) {
		return UtilsService.getlegendMarkerPath(
			item,
			"deepdive",
			GlobalConstants.SvgLinSettingsCollection.statisticalForecastingSettings
		);
	}

	//? GOOD.
	public toggleAssumptionsAdditionalData() {
		this.showAssumptionsAdditionalData = !this.showAssumptionsAdditionalData;
	}

	//? GOOD.
	public toggleInvAdditionalData() {
		this.showInventoryAdditionalData = !this.showInventoryAdditionalData;
	}

	//? GOOD.
	public toggleStockOutAdditionalData() {
		this.showStockOutAdditionalData = !this.showStockOutAdditionalData;
	}

	//? GOOD.
	public toggleScrapAdditonalData() {
		this.showScrapAdditionalData = !this.showScrapAdditionalData;
	}

	//? GOOD.
	public toggleProdChangeData() {
		this.showProdChangeCost = !this.showProdChangeCost;
	}

	//? GOOD.
	public changeInfoPopupStatus() {
		this.showInfoPopup = !this.showInfoPopup;
		this.infoPopupMessage = "";
	}

	private initializeGridData() {
		const $this = this;

		this.esoService.getEsoDeepDiveGridData(null, null, { showLoadingIndicator: false }).subscribe(
			(response) => {
				$this.gridColumns = [];
				if (response != null && response.gridData.columns != null) {
					for (var i = 0; i < response.gridData.columns.length; i++) {
						var dataTypeValue = "string";
						if ($this.SettingDecimal != null && $this.SettingDecimal.length > 0) {
							var itemFilter = $this.SettingDecimal.find(x => x.name == response.gridData.columns[i].columnName);
							if (itemFilter != null) {
								dataTypeValue = "number";
							}
						}
						$this.gridColumns.push({
							caption: response.gridData.columns[i].caption,
							columnName: response.gridData.columns[i].columnName,
							dataType: dataTypeValue
						})
					}
				}

				$this.gridData = response.gridData.data;

				this.LoadChartSeries();
				this.loadLengendToShare();
				setTimeout(() => {
					this.bookmarksGroup.applyDefaultBookmark();
				}, 0);

			},
			(error) => {

				$this.notificationError(error);
			}
		);
	}


	private initializeSelectedProductData(action: string, showLoader: boolean = true) {

		const observable$ = this.esoServise.getProduct(this.selectedProduct.code, this.selectedSecondScenario, this.selectedFirstScenario, { showLoadingIndicator: showLoader, showErrorNotification: false, errorLoggingEnabled: false });

		const $this = this;

		return observable$.toPromise().then(
			(response) => {
				if (response[0]) {
					//selectedProduct updated
					$this.loadProductData(action, response[0]);
					$this.CalculateFinancialData();
					$this.selectedProduct.calculationRatio = this.selectedProduct.calculationRatio * 100;
				}

			},
			(error) => {
				//$this.notificationError(error);
				throw error;
			}
		);
	}

	public initializeAutocompleteList(filterByValue: boolean = false, value: string = "") {
		let source = this.allProducts.map((product) => product.code);
		if (filterByValue && value.length >= 3) {
			source = source.filter(product => product.indexOf(value) > -1);
		}
		this.productsAutocompleteDataSource = source;
	}


	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		//creating new data source
		let gridData = new DataSource(
			<Options>
			{
				store: this.dataGrid.dataSource,
				paginate: false
			}
		);

		//Getting all Filtering
		let filterExpr = evt.component.getCombinedFilter();
		if (filterExpr != null) {
			gridData.filter(filterExpr);
		}

		//Getting all sorting
		let sortingExpres = evt.component.getDataSource().sort();
		if (sortingExpres != null) {
			gridData.sort(sortingExpres);
		}

		gridData.load().then(
			(result) => {
				this.productsAutocompleteDataSource = result.map(product => product.ProductId);
			}
		);

		const curFilter = evt.component.getCombinedFilter();
		if (curFilter) {
			this.anyActiveFilters = true;
		} else {
			this.anyActiveFilters = false;
		}

		this.dxDataGridOperator.updateRowCount(evt.component);

		localStorage.setItem('grid-state-eso-deep', JSON.stringify(this.dataGrid.instance.state()));
	}


	public selectProduct(productId: string, showLoader: boolean = false) {
		const $this = this;

		// Create a new Temp Product until selected one is initialized, because many methods use this.selectedProduct to access code property.
		this.selectedProduct.code = productId;

		this._restrictSecondScenarioChartUpdate = true;

		this.focusedRowKey = this.allProducts.findIndex((item) => item.code === this.selectedProduct.code);

		if (this.allProducts != undefined && this.allProducts != null && this.allProducts.length != 0 && this.focusedRowKey == -1) {
			this.notificationError("You do not have access to this item.");
			setTimeout(
				() => {
					window.location.reload();
				},
				2000
			);
		}
		else {
			const url = `eso/deep-dive?${this._productIdQueryParamName}=${UtilsService.getURLHelper(this.selectedProduct.code)}`;
			this.location.replaceState(url);
			this.initializeSelectedProductData("pageload", showLoader).then(
				(ProductData) => {

					// Initializing scenarios data is required only when we select a new product.
					$this.initializeScenariosData(0, 1, false).then(
						(ScenariosData) => {
							// Load data for and set 3 charts - Actual Sales vs Forecast | Forecast Error | Actual Inventory | Master Table
							this.SelectObjects(productId).then(() => {
								$this.initializeStockOutChartDataSource($this.selectedProduct, false, "pageload", showLoader);
								this.scrollTop();
							});
						}
					);
				},
				(error) => {
					$this.notificationError(error.error);
					let SelectedProductCode = this.selectedProduct.code;
					this.selectedProduct = new Product();
					this.selectedProduct.code = SelectedProductCode;
					this.blankDataIfError();
				}
			);
		}
	}

	public initializeScenariosData(depth: number = 0, maxDepth: number = 1, showLoader: boolean = false) {
		const $this = this;

		if (!this.selectedProduct.hasOwnProperty("productSuID")) {
			return undefined;
		}

		let getScenario$ = this.esoServise.getScenario(this.selectedProduct.productSuID.toString(), { showLoadingIndicator: showLoader }).toPromise();
		getScenario$.then(
			(response) => {
				$this.scenariosDropdownOptions = [];

				if (response && response.length < 2) {
					$this.scenarios = [];
					$this.selectedFirstScenarioName = "";
					$this.selectedSecondScenarioName = "";

					if (depth < maxDepth) {
						$this.runProductSimulation().then(
							(response) => {
								$this.initializeScenariosData(depth + 1, maxDepth);
							},
							(error) => {
							}
						);
					}

				} else if (response) {
					$this.scenarios = response;

					$this.selectedFirstScenario = response[0];

					let targetServiceLevel = response.find((scenario) => scenario.name.startsWith("Target Service Level"));
					if (targetServiceLevel) {
						$this.selectedSecondScenario = targetServiceLevel;
					}
					else {
						$this.selectedSecondScenario = response[1];
					}

					$this.selectedFirstScenarioName = $this.selectedFirstScenario.name;
					$this.selectedSecondScenarioName = $this.selectedSecondScenario.name;


					for (let i = 0; i <= response.length - 1; i++) {
						$this.scenariosDropdownOptions.push(response[i].name);
					}
					//Due to below API calling multiple times --commented by Bhargavi.


					$this.scenariosSecondDropdownOptions = {
						items: response,
						value: this.selectedSecondScenario.name,
						displayExpr: "name",
						valueExpr: "name",
						bindingOptions: {
							value: "selectedSecondScenario",
						},
					};
				}

			},
			(error) => {


				$this.notificationError(error);
			}
		);

		return getScenario$;
	}


	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	public runProductSimulation(): Promise<Production[]> {
		const $this = this;
		this.IsSafetyStockChange = false;

		const productSimulationObservable$ = this.esoServise.runProductSimulation(this.selectedProduct.code, 2, { showLoadingIndicator: true, showErrorNotification: false, errorLoggingEnabled: false }).toPromise();

		productSimulationObservable$.then(
			(response) => {

				$this.infoPopupMessage = "Simulation was performed successfully.";
				$this.showInfoPopup = true;
				//$this.hideInfoPopupWithDelay();

				// This is required because Angular caches templates in browser and pop up is a template.
				$this.changeDetectorRef.detectChanges();

				$this.selectProduct($this.selectedProduct.code, false);
			},
			(error) => {
				$this.infoPopupMessage = "Product did not pass validation and cannot be simulated.";
				$this.showInfoPopup = true;
				$this.hideInfoPopupWithDelay();
				// This is required because Angular caches templates in browser and pop up is a template.
				$this.changeDetectorRef.detectChanges();
				//$this.notificationError(error);
			}
		);

		return productSimulationObservable$;

	}

	private setDataForActualInventoryChart(array: Production[]) {
		this.actualInventoryDataSource = [];

		const itemsArrayCount = array.length - 1;

		for (let i = 0; i < itemsArrayCount; i++) {
			const item = array[i];
			var Cals = (itemsArrayCount === i ? 0 : (array[i + 1].stock - item.stock) + item.actualRaw);
			const inventoryAdjustment = (Cals < 0 ? Cals : 0);
			const productionAdjustment = (Cals > 0 ? Cals : 0);
			const newItem: ActualInventory = {
				periodId: item.periodId,
				inventoryOpenning: item.stock,
				sales: -item.actualRaw,
				invAdjustments: inventoryAdjustment <= 0 ? inventoryAdjustment : 0.0,
				productionPurchase: productionAdjustment > 0 ? productionAdjustment : 0.0,
			};

			this.actualInventoryDataSource.push(newItem);
		}
	}

	private setDataForecastErrorChart(array: Production[]) {
		this.forecastErrorDataSourse = [];

		array.forEach(
			(item) => {
				const newItem: ForecastError = {
					periodId: item.periodId,

					forecast: item.forecast,
					forecastError: item.forecastError,
				};

				this.forecastErrorDataSourse.push(newItem);
			}
		);
	}

	private setForecastAndActualDataChart(array: Production[]) {
		this.forecastAndActualDataSource = [];

		array.forEach(
			(item) => {
				const newItem: ForecastAndActual = {
					periodId: item.periodId,

					actualRaw: item.actualRaw,
					actualClean: item.actualClean,

					forecast: item.forecast,
					forecastClean: item.forecastClean,
				};

				this.forecastAndActualDataSource.push(newItem);
			}
		);
	}


	selectedFirstScenarioChanged({ value }: DxSelectBoxTypes.ValueChangedEvent) {
		this.cleanUpCustomScenario();
		if (value) {
			this.selectedFirstScenario = this.scenarios.find((scenario) => scenario.name === value.toString());
			if (this.IsSafetyStockChange) {
				this.runProductSimulation();
			} else {
				this.initializeSelectedProductData("FirstScenario", false).then(
					(response) => {

					}
				);
			}
		}
	}

	public selectedSecondScenarioChanged({ value }: DxSelectBoxTypes.ValueChangedEvent) {
		const $this = this;
		if (value) {
			this.selectedSecondScenario = this.scenarios.find((scenario) => scenario.name === value.toString());
		}
		$this.cleanUpCustomScenario();
		this.secondScenarioChanged(false);
	}
	secondScenarioChanged(edited: boolean) {
		// this.initializeSelectedProductData("SecondScenario", false).then(
		// 	(response) => {
		this.initializeStockOutChartDataSource(this.selectedProduct, false, "SecondScenario", false).add(() => {
			this.initializeSelectedProductData("SecondScenario", false).then(
				(response) => {
					this.CalculateFinancialData();
				});
			// if (edited) {
			// 	this.introduceCustomScenario();
			// }
		});
		//}
		//);
	}

	private cleanUpCustomScenario() {
		let customScenario = this.scenarios.find((scenario) => scenario.name === 'Custom');
		if (customScenario) {
			this.scenarios.pop();
			this.scenariosDropdownOptions.pop();
			//upd
		}
		//this.selectedSecondScenario.name = this.scenarioBackupName;
	}

	scenarioBackupName = '';
	private introduceCustomScenario() {
		if (!this.scenarios.find((scenario) => scenario.name === 'Custom')) {
			let customScenario = structuredClone(this.selectedSecondScenario);
			customScenario.name = 'Custom';

			this.scenarios.push(customScenario);
			this.scenariosDropdownOptions.push(customScenario.name);
			this.selectedSecondScenario = customScenario;
			this.selectedSecondScenarioName = customScenario.name;
		} else {
			let selectedCurrently = this.scenarios.find((scenario) => scenario.name === 'Custom');
			this.selectedSecondScenario = selectedCurrently;
			this.selectedSecondScenarioName = selectedCurrently.name;
		}

		// this.scenarioBackupName = this.selectedSecondScenario.name;
		// this.selectedSecondScenario.name = 'Custom';
	}


	//? GOOD.
	public onLegendClick(e: any) {
		const series = e.target;

		if (series.isVisible()) {
			series.hide();
		} else {
			series.show();
		}
		this.loadLengendToShare();
	}

	IsSafetyStockChange = false;
	customSafetyStock = 0;
	customLotSize = 0;


	//IsSafetyStockChange = true;

	public onStockFocusOut(e) {
		this.secondScenarioChanged(true);
	}

	public onLotFocusOut(e) {
		this.secondScenarioChanged(true);
	}


	//! TEST.
	private saveAssumptionsSubscription: Subscription;

	//! TEST.
	public onSaveAssumptionsClick() {
		const $this = this;

		//? DB has different format.
		this.selectedProduct.calculationRatio = this.selectedProduct.calculationRatio / 100;

		this.esoServise.saveAssumptions(this.selectedProduct, 2).subscribe(
			(response) => {

				//? DB has different format.
				$this.selectedProduct.calculationRatio = this.selectedProduct.calculationRatio * 100;

				$this.infoPopupMessage = "Assumptions updated successfully!";
				$this.showInfoPopup = true;
				$this.hideInfoPopupWithDelay();

				// This is required because Angular caches templates in browser and pop up is a template.
				$this.changeDetectorRef.detectChanges();

				$this.runProductSimulation();


			},
			(error) => {

				$this.notificationError(error);
			}
		);
	}

	//! TEST.
	public onResetAssumptionsClick() {
		const $this = this;


		this.esoServise.resetAssumptions(this.selectedProduct, 2).subscribe(
			(response) => {

				$this.hideInfoPopupWithDelay();
				$this.infoPopupMessage = "Assumptions reset successfully!";
				$this.showInfoPopup = true;
				// This is required because Angular caches templates in browser and pop up is a template.
				$this.changeDetectorRef.detectChanges();

				$this.selectProduct($this.selectedProduct.code);
			},
			(error) => {

				$this.notificationError(error);
			}
		);
	}

	//TODO: Move to utility.
	//? GOOD.
	private scrollTop() {
		const el = document.getElementById("anchor");

		setTimeout(
			() => {
				if (el) {
					el.scrollIntoView({ behavior: "smooth", block: "center" });
				}
			},
			1
		);
	}


	private initializeStockOutChartDataSource(
		product: Product,
		isDynamicChartUpdate: boolean, action: string,
		showLoader: boolean = false
	) {
		const $this = this;


		const safetyStock: number = this.selectedSecondScenario.hasOwnProperty('safetyStock') && this.selectedSecondScenario.safetyStock !== null && this.selectedSecondScenario.safetyStock !== undefined
			? this.selectedSecondScenario.safetyStock : 1;

		const lotSize: number = this.selectedSecondScenario.hasOwnProperty('lotSize') && this.selectedSecondScenario.lotSize !== null && this.selectedSecondScenario.lotSize !== undefined
			? this.selectedSecondScenario.lotSize : 1;

		const sourceId: number = 1;

		return this.esoServise.getProductSimulatedData(product.code, safetyStock, lotSize, sourceId, { showLoadingIndicator: showLoader }).subscribe(
			(response) => {
				$this.stockOutDataSourse = response.stockOuts;

				if (isDynamicChartUpdate) {
					//selectedProduct updated
					$this.loadProductData(action, response.product);
					$this.CalculateFinancialData();
					if (response.product != null && response.product.serviceLevelAsIsNew != null) {
						this.selectedFirstScenario.serviceLevel = response.product.serviceLevelAsIsNew;
					}
				}

			},
			(error) => {
				$this.notificationError(error);
			},
		);
	}

	loadProductData(action: string, productData: any) {
		if (action == null || action == undefined) {
			this.selectedProduct = productData;
		}
		else if (action == "FirstScenario") {
			// Check each property and only assign if the value is not null
			this.selectedProduct.inventoryUnitsAsIs = productData.inventoryUnitsAsIs !== null ? productData.inventoryUnitsAsIs : this.selectedProduct.inventoryUnitsAsIs;
			this.selectedProduct.inventoryAmountAsIs = productData.inventoryAmountAsIs !== null ? productData.inventoryAmountAsIs : this.selectedProduct.inventoryAmountAsIs;
			//this.selectedProduct.cogsAsIs = productData.cogsAsIs !== null ? productData.cogsAsIs : this.selectedProduct.cogsAsIs;
			this.selectedProduct.inventoryCapitalAsIs = productData.inventoryCapitalAsIs !== null ? productData.inventoryCapitalAsIs : this.selectedProduct.inventoryCapitalAsIs;
			this.selectedProduct.inventoryOpexAsIs = productData.inventoryOpexAsIs !== null ? productData.inventoryOpexAsIs : this.selectedProduct.inventoryOpexAsIs;
			this.selectedProduct.stockOutAsIs = productData.stockOutAsIs !== null ? productData.stockOutAsIs : this.selectedProduct.stockOutAsIs;
			this.selectedProduct.unplannedProductionChangeAsIs = productData.unplannedProductionChangeAsIs !== null ? productData.unplannedProductionChangeAsIs : this.selectedProduct.unplannedProductionChangeAsIs;
			this.selectedProduct.scrapAsIs = productData.scrapAsIs !== null ? productData.scrapAsIs : this.selectedProduct.scrapAsIs;
		}
		else if (action == "SecondScenario") {
			// For each property, check if the value is not null before assigning it
			// If the value is null, keep the existing value of the property
			this.selectedProduct.inventoryUnitsToBe = productData.inventoryUnitsToBe !== null ? productData.inventoryUnitsToBe : this.selectedProduct.inventoryUnitsToBe;
			this.selectedProduct.inventoryAmountToBe = productData.inventoryAmountToBe !== null ? productData.inventoryAmountToBe : this.selectedProduct.inventoryAmountToBe;
			this.selectedProduct.cogsToBe = productData.cogsToBe !== null ? productData.cogsToBe : this.selectedProduct.cogsToBe;
			this.selectedProduct.inventoryCapitalToBe = productData.inventoryCapitalToBe !== null ? productData.inventoryCapitalToBe : this.selectedProduct.inventoryCapitalToBe;
			this.selectedProduct.inventoryOpexToBe = productData.inventoryOpexToBe !== null ? productData.inventoryOpexToBe : this.selectedProduct.inventoryOpexToBe;
			this.selectedProduct.stockOutToBe = productData.stockOutToBe !== null ? productData.stockOutToBe : this.selectedProduct.stockOutToBe;
			this.selectedProduct.unplannedProductionChangeToBe = productData.unplannedProductionChangeToBe !== null ? productData.unplannedProductionChangeToBe : this.selectedProduct.unplannedProductionChangeToBe;
			this.selectedProduct.scrapToBe = productData.scrapToBe !== null ? productData.scrapToBe : this.selectedProduct.scrapToBe;
		}
		else {
			this.selectedProduct = productData;
		}
	}


	//? GOOD.
	public calculatePersentDiffenrence(firstArg: number, secondArg: number): number {
		if (secondArg) {
			return ((firstArg - secondArg) / secondArg) * 100;
		}
		return 0;
	}

	//? GOOD.
	public calculateTotalDifferesnse(): number {
		if (this.selectedProduct) {
			return (
				this.selectedProduct.scrapToBe -
				this.selectedProduct.scrapAsIs +
				(this.selectedProduct.stockOutToBe - this.selectedProduct.stockOutAsIs) +
				(this.selectedProduct.inventoryOpexToBe - this.selectedProduct.inventoryOpexAsIs) +
				(this.selectedProduct.inventoryCapitalToBe -
					this.selectedProduct.inventoryCapitalAsIs) +
				(this.selectedProduct.cogsToBe - this.selectedProduct.cogsAsIs)
			);
		} else {
			return 0;
		}
	}

	//? GOOD
	public calculateTotalPersentDifference(): number {
		if (this.selectedProduct) {
			return this.calculatePersentDiffenrence(
				this.selectedProduct.cogsAsIs +
				this.selectedProduct.inventoryCapitalAsIs +
				this.selectedProduct.inventoryOpexAsIs +
				this.selectedProduct.stockOutAsIs +
				this.selectedProduct.scrapAsIs,

				this.selectedProduct.cogsToBe +
				this.selectedProduct.inventoryCapitalToBe +
				this.selectedProduct.inventoryOpexToBe +
				this.selectedProduct.stockOutToBe +
				this.selectedProduct.scrapToBe
			);
		} else {
			return 0;
		}
	}

	//! TEST.
	public onProductChange(event) {
		this.selectProduct(event);
	}

	public onAutocompleteEnterKey(event) {
		this.selectProduct(event);
	}

	//? GOOD.
	public onGridActionItemClicked(item: any) {
		this.selectProduct(item.data.ProductId);
	}

	//? GOOD.
	public onHelpButtonClicked(event, settingName: string) {
		this.helpService.openHelpPage(settingName);
	}



	//adding customize setting with title, change title if need.
	customizeTooltip = (info: any) => {
		return DevTooltipCustComponent.customizeTooltip(info, "", "", "");
	}

	notificationError(param1: any) {
		console.error(param1);
		if (typeof param1 === "string") {
			param1 = "Product did not pass validation.";

			this.infoPopupMessage = param1;
			this.showInfoPopup = true;
		}

		if (param1.error) {
			param1.error = "Product did not pass validation.";

			this.infoPopupMessage = param1.error;
			this.showInfoPopup = true;
		}

	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift({
			location: 'before',
			template: 'expandButtonTemplate'
		}, {
			location: 'before',
			template: 'heightButtonTemplate'
		}, {
			location: 'after',
			template: 'appliedFiltersButtonTemplate'
		}, {
			location: 'before',
			template: 'bookmarkButtonTemplate'
		});
	}

	ScopeList = [];
	saveState = (statenew) => {
		this.ScopeList = [];
		if (statenew != null && statenew.columns != null && statenew.columns.length > 0) {
			statenew.columns.forEach(element => {
				if (element.filterValues) {
					this.ScopeList.push({
						fieldName: element.dataField, filterType: element.filterType,
						value: element.filterValues
					});
				}
			});
		}
		this.loadLengendToShare();

		this.shareDataService.dataGridState = JSON.stringify(statenew);
	}

	anyActiveFilters = false;

	changeActiveFiltersStatus() {
		if (this.anyActiveFilters) {
			this.anyActiveFilters = !this.anyActiveFilters;
			this.dataGrid.instance.clearFilter();
			this.ScopeList = [];
			this.ChartSettings.ScopeList = [];
		}
	}
	fitTableToPage = false;

	changeFitToPageStatus() {
		this.fitTableToPage = !this.fitTableToPage;
		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});

		this.dataGrid.instance.state(currentState);
	}

	SettingDecimal: any;
	loadLengendToShare() {
		var seriesValues = { ActualSalesVsForecast: [], ForecastError: [], ActualInventory: [], FutureForecast: [], SimulatedInventory: [], LeadTime: [], ScopeList: [] };
		if (this.dxActualSalesVsForecast != null && this.dxActualSalesVsForecast.instance != null
			&& this.dxActualSalesVsForecast.instance.getAllSeries() != null) {
			this.dxActualSalesVsForecast.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ActualSalesVsForecast.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxForecastError != null && this.dxForecastError.instance != null
			&& this.dxForecastError.instance.getAllSeries() != null) {
			this.dxForecastError.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ForecastError.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxActualInventory != null && this.dxActualInventory.instance != null
			&& this.dxActualInventory.instance.getAllSeries() != null) {
			this.dxActualInventory.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.ActualInventory.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxFutureForecast != null && this.dxFutureForecast.instance != null
			&& this.dxFutureForecast.instance.getAllSeries() != null) {
			this.dxFutureForecast.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.FutureForecast.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxSimulatedInventory != null && this.dxSimulatedInventory.instance != null
			&& this.dxSimulatedInventory.instance.getAllSeries() != null) {
			this.dxSimulatedInventory.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.SimulatedInventory.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		if (this.dxLeadTime != null && this.dxLeadTime.instance != null
			&& this.dxLeadTime.instance.getAllSeries() != null) {
			this.dxLeadTime.instance.getAllSeries().forEach(item => {
				if (item.name != null && item["getValueFields"]() && item["getValueFields"]().length > 0) {
					seriesValues.LeadTime.push({ ValueField: item["getValueFields"]()[0], Name: item.name, isVisible: item.isVisible() });
				}
			})
		}

		seriesValues.ScopeList = this.ScopeList;
		this.shareDataService.ChartSettings = JSON.stringify(seriesValues);
	}

	ChartSettings: any;
	LoadChartSeries() {

		if (this.dxActualSalesVsForecast != null && this.dxActualSalesVsForecast.series != null
			&& Array.isArray(this.dxActualSalesVsForecast.series) && this.dxActualSalesVsForecast.series.length > 0) {
			for (let index = 0; index < this.dxActualSalesVsForecast.series.length; index++) {
				this.dxActualSalesVsForecast.series[index].visible = true;
			}
		}

		if (this.dxForecastError != null && this.dxForecastError.series != null
			&& Array.isArray(this.dxForecastError.series) && this.dxForecastError.series.length > 0) {
			for (let index = 0; index < this.dxForecastError.series.length; index++) {
				this.dxForecastError.series[index].visible = true;
			}
		}

		if (this.dxActualInventory != null && this.dxActualInventory.series != null
			&& Array.isArray(this.dxActualInventory.series) && this.dxActualInventory.series.length > 0) {
			for (let index = 0; index < this.dxActualInventory.series.length; index++) {
				this.dxActualInventory.series[index].visible = true;
			}
		}

		if (this.dxFutureForecast != null && this.dxFutureForecast.series != null
			&& Array.isArray(this.dxFutureForecast.series) && this.dxFutureForecast.series.length > 0) {
			for (let index = 0; index < this.dxFutureForecast.series.length; index++) {
				this.dxFutureForecast.series[index].visible = true;
			}
		}

		if (this.dxSimulatedInventory != null && this.dxSimulatedInventory.series != null
			&& Array.isArray(this.dxSimulatedInventory.series) && this.dxSimulatedInventory.series.length > 0) {
			for (let index = 0; index < this.dxSimulatedInventory.series.length; index++) {
				this.dxSimulatedInventory.series[index].visible = true;
			}
		}

		if (this.dxLeadTime != null && this.dxLeadTime.series != null
			&& Array.isArray(this.dxLeadTime.series) && this.dxLeadTime.series.length > 0) {
			for (let index = 0; index < this.dxLeadTime.series.length; index++) {
				this.dxLeadTime.series[index].visible = true;
			}
		}


		if (this.ChartSettings != null) {

			if (this.ChartSettings.ActualSalesVsForecast != null && this.ChartSettings.ActualSalesVsForecast.length > 0) {
				if (this.dxActualSalesVsForecast != null && this.dxActualSalesVsForecast.series != null
					&& Array.isArray(this.dxActualSalesVsForecast.series) && this.dxActualSalesVsForecast.series.length > 0) {
					for (let index = 0; index < this.dxActualSalesVsForecast.series.length; index++) {
						this.ChartSettings.ActualSalesVsForecast.forEach(itemchrt => {
							if (this.dxActualSalesVsForecast.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxActualSalesVsForecast.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxActualSalesVsForecast.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxActualSalesVsForecast.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.ForecastError != null && this.ChartSettings.ForecastError.length > 0) {
				if (this.dxForecastError != null && this.dxForecastError.series != null
					&& Array.isArray(this.dxForecastError.series) && this.dxForecastError.series.length > 0) {
					for (let index = 0; index < this.dxForecastError.series.length; index++) {
						this.ChartSettings.ForecastError.forEach(itemchrt => {
							if (this.dxForecastError.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxForecastError.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxForecastError.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxForecastError.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.ActualInventory != null && this.ChartSettings.ActualInventory.length > 0) {
				if (this.dxActualInventory != null && this.dxActualInventory.series != null
					&& Array.isArray(this.dxActualInventory.series) && this.dxActualInventory.series.length > 0) {
					for (let index = 0; index < this.dxActualInventory.series.length; index++) {
						this.ChartSettings.ActualInventory.forEach(itemchrt => {
							if (this.dxActualInventory.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxActualInventory.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxActualInventory.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxActualInventory.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.FutureForecast != null && this.ChartSettings.FutureForecast.length > 0) {
				if (this.dxFutureForecast != null && this.dxFutureForecast.series != null
					&& Array.isArray(this.dxFutureForecast.series) && this.dxFutureForecast.series.length > 0) {
					for (let index = 0; index < this.dxFutureForecast.series.length; index++) {
						this.ChartSettings.FutureForecast.forEach(itemchrt => {
							if (this.dxFutureForecast.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxFutureForecast.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxFutureForecast.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxFutureForecast.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.SimulatedInventory != null && this.ChartSettings.SimulatedInventory.length > 0) {
				if (this.dxSimulatedInventory != null && this.dxSimulatedInventory.series != null
					&& Array.isArray(this.dxSimulatedInventory.series) && this.dxSimulatedInventory.series.length > 0) {
					for (let index = 0; index < this.dxSimulatedInventory.series.length; index++) {
						this.ChartSettings.SimulatedInventory.forEach(itemchrt => {
							if (this.dxSimulatedInventory.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxSimulatedInventory.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxSimulatedInventory.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxSimulatedInventory.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.ChartSettings.ScopeList != null && this.ChartSettings.ScopeList.length > 0) {
				if (this.dataGrid != null && this.dataGrid.instance != null) {
					this.ChartSettings.ScopeList.forEach(element => {
						this.dataGrid.instance.beginUpdate();
						this.dataGrid.instance.columnOption(element.fieldName, 'filterType', 'include');
						if (element.filterType != null && element.filterType != undefined) {
							this.dataGrid.instance.columnOption(element.fieldName, 'filterType', element.filterType);
						}
						this.dataGrid.instance.columnOption(element.fieldName, 'filterValues', element.value);
						this.dataGrid.instance.endUpdate();
					});
				}
			}

			if (this.ChartSettings.LeadTime != null && this.ChartSettings.LeadTime.length > 0) {
				if (this.dxLeadTime != null && this.dxLeadTime.series != null
					&& Array.isArray(this.dxLeadTime.series) && this.dxLeadTime.series.length > 0) {
					for (let index = 0; index < this.dxLeadTime.series.length; index++) {
						this.ChartSettings.LeadTime.forEach(itemchrt => {
							if (this.dxLeadTime.series[index].valueField != null
								&& itemchrt.isVisible != null && (this.dxLeadTime.series[index].valueField.toLowerCase() == itemchrt.ValueField.toLowerCase()
									|| this.dxLeadTime.series[index].name.toLowerCase() == itemchrt.ValueField.toLowerCase())
							) {
								this.dxLeadTime.series[index].visible = itemchrt.isVisible;
							}
						});
					}
				}
			}

			if (this.dxActualSalesVsForecast) { this.dxActualSalesVsForecast.instance.refresh(); }
			if (this.dxForecastError) { this.dxForecastError.instance.refresh(); }
			if (this.dxActualInventory) { this.dxActualInventory.instance.refresh(); }
			if (this.dxFutureForecast) { this.dxFutureForecast.instance.refresh(); }
			if (this.dxSimulatedInventory) { this.dxSimulatedInventory.instance.refresh(); }
			if (this.dxLeadTime) { this.dxLeadTime.instance.refresh(); }


		}
	}
	onClick(event) {
		var target = event.target || event.srcElement || event.currentTarget;
		var srcAttr = target.attributes.src;
		this.imgSrc = srcAttr.nodeValue;
		this.ImgTitle = target.title;
		this.ImageInfoPopup = true
	}

	/* Eso Difference Calculation */

	NullCheckFormatNA(values: any, minimumFractionDigits: number, maximumFractionDigits) {
		if (values != undefined && values != null) {
			return values.toLocaleString(this.locale,
				{
					minimumFractionDigits:
						minimumFractionDigits,
					maximumFractionDigits: maximumFractionDigits
				});
		}
		return 'NA'
	}

	NullCheckFormatZero(values: any, minimumFractionDigits: number, maximumFractionDigits) {
		if (values != undefined && values != null) {
			return values.toLocaleString(this.locale,
				{
					minimumFractionDigits:
						minimumFractionDigits,
					maximumFractionDigits: maximumFractionDigits
				});
		}
		return '0'
	}

	NullCheckFormatZeroScrap(values: any, minimumFractionDigits: number, maximumFractionDigits) {
		if (values != undefined && values != null) {
			if (values != 0) {
				values = -values;
			}
			return values.toLocaleString(this.locale,
				{
					minimumFractionDigits:
						minimumFractionDigits,
					maximumFractionDigits: maximumFractionDigits
				});
		}
		return '0'
	}

	NullCheck(values: any) {
		return values = Math.round(values) ?? 0;
	}

	NullCheckDivideByZero(numerator: number, denominator: number) {
		numerator = this.NullCheck(numerator);
		denominator = this.NullCheck(denominator);

		if (denominator === 0) {
			return 'NA';
		} else {
			return this.NullCheck((numerator / denominator) * 100).toString() + '%';
		}
	}


	CalculateFinancialData() {
		if (this.selectedProduct) {
			//cogs difference calculation
			this.selectedProduct.cogsDiff = this.NullCheck(this.selectedProduct.cogsToBe) - this.NullCheck(this.selectedProduct.cogsAsIs);
			this.selectedProduct.cogsPercentage = this.NullCheckDivideByZero(this.selectedProduct.cogsDiff, this.selectedProduct.cogsAsIs);

			//inventory Capital difference calculation
			this.selectedProduct.inventoryCapitalDiff = this.NullCheck(this.selectedProduct.inventoryCapitalToBe) - this.NullCheck(this.selectedProduct.inventoryCapitalAsIs);
			this.selectedProduct.inventoryCapitalPercentage = this.NullCheckDivideByZero(this.selectedProduct.inventoryCapitalDiff, this.selectedProduct.inventoryCapitalAsIs);

			//inventory Opex difference calculation
			this.selectedProduct.inventoryOpexDiff = this.NullCheck(this.selectedProduct.inventoryOpexToBe) - this.NullCheck(this.selectedProduct.inventoryOpexAsIs);
			this.selectedProduct.inventoryOpexPercentage = this.NullCheckDivideByZero(this.selectedProduct.inventoryOpexDiff, this.selectedProduct.inventoryOpexAsIs);

			//stock Out difference calculation
			this.selectedProduct.stockOutDiff = this.NullCheck(this.selectedProduct.stockOutToBe) - this.NullCheck(this.selectedProduct.stockOutAsIs);
			this.selectedProduct.stockOutPercentage = this.NullCheckDivideByZero(this.selectedProduct.stockOutDiff, this.selectedProduct.stockOutAsIs);

			//unplanned Production Change difference calculation
			this.selectedProduct.unplannedProductionChangeDiff = this.NullCheck(this.selectedProduct.unplannedProductionChangeToBe) - this.NullCheck(this.selectedProduct.unplannedProductionChangeAsIs);
			this.selectedProduct.unplannedProductionChangePercentage = this.NullCheckDivideByZero(this.selectedProduct.unplannedProductionChangeDiff, this.selectedProduct.unplannedProductionChangeAsIs);

			//scrap Change difference calculation
			//- scrapToBe Always negative which should be consider as positive and then scrapAsIs is also negative which will be subtract
			this.selectedProduct.scrapDiff = (this.NullCheck(-this.selectedProduct.scrapToBe)) + this.NullCheck(this.selectedProduct.scrapAsIs);
			this.selectedProduct.scrapPercentage = this.NullCheckDivideByZero(this.selectedProduct.scrapDiff, -this.selectedProduct.scrapAsIs);

			//total calculation
			this.selectedProduct.totalDiff = this.selectedProduct.cogsDiff + this.selectedProduct.inventoryCapitalDiff + this.selectedProduct.inventoryOpexDiff + this.selectedProduct.stockOutDiff + this.selectedProduct.unplannedProductionChangeDiff + this.selectedProduct.scrapDiff;
			this.selectedProduct.totalAsIs = this.NullCheck(this.selectedProduct.cogsAsIs) + this.NullCheck(this.selectedProduct.inventoryCapitalAsIs) + this.NullCheck(this.selectedProduct.inventoryOpexAsIs) + this.NullCheck(this.selectedProduct.stockOutAsIs) + this.NullCheck(this.selectedProduct.unplannedProductionChangeAsIs) + this.NullCheck(-this.selectedProduct.scrapAsIs);
			this.selectedProduct.totalToBe = this.NullCheck(this.selectedProduct.cogsToBe) + this.NullCheck(this.selectedProduct.inventoryCapitalToBe) + this.NullCheck(this.selectedProduct.inventoryOpexToBe) + this.NullCheck(this.selectedProduct.stockOutToBe) + this.NullCheck(this.selectedProduct.unplannedProductionChangeToBe) + this.NullCheck(-this.selectedProduct.scrapToBe);
			this.selectedProduct.totalPercentage = this.NullCheckDivideByZero(this.selectedProduct.totalDiff, this.selectedProduct.totalAsIs);

			//top section calculation
			//Inventory Value
			this.selectedProduct.inventoryAmountDiff = this.NullCheck(this.selectedProduct.inventoryAmountToBe) - this.NullCheck(this.selectedProduct.inventoryAmountAsIs);
			this.selectedProduct.inventorAmountPercentage = this.NullCheckDivideByZero(this.selectedProduct.inventoryAmountDiff, this.selectedProduct.inventoryAmountAsIs);

			//Inventory Value
			this.selectedProduct.inventoryUnitsDiff = this.NullCheck(this.selectedProduct.inventoryUnitsToBe) - this.NullCheck(this.selectedProduct.inventoryUnitsAsIs);
			this.selectedProduct.inventoryUnitsPercentage = this.NullCheckDivideByZero(this.selectedProduct.inventoryUnitsDiff, this.selectedProduct.inventoryUnitsAsIs);


		}
	}


	showDecisionParametersData = false;
	showFinancialData = true;

	//Testing code add by amit
	IsExportListEnable = false;
	esoDeepDiveDisplayChartFutureFCCoreSetting: string = "no";
	esoDeepDiveDisplayChartLeadTimeCoreSetting: string = "no";

	//tooltip
	EnableTooltip = false;
	ShowTooltip = false;
	EsoOverviewDeepDiveDecimalPlace: number = 0;
	SimulateDetails = [];
	initializeAllSettings() {
		this.settingsService.AllEsoSettings().subscribe(result => {
			if (result != null) {
				this.SettingDecimal = result["currencyField"] || [];
				this.yearWeeks = result["yearWeeks"] || [];
				this.SimulateDetails = result["simulateDetails"] || [];
				result["settings"]?.forEach(item => {
					switch (item.name) {
						case "EsoObjectProductImagePath":
							this.ProductImagePath = item.value;
							break;
						case "EsoObjectProductImageHeight":
							this.ProductImageHeight = item.value;
							break;
						case "EnableExportEsODeepDivelist":
							this.IsExportListEnable = this.parseBoolean(item.value);
							break;
						case "EsoDDProductionCaption":
							this.productionLegendChartCaption = item.value;
							break;

						case "EsoDDSalesCaption":
							this.salesLegendChartCaption = item.value;
							break;
						case "EsoDDInventoryOpenningCaption":
							this.inventoryOpenningLegendChartCaption = item.value;
							break;
						case "EsoDDInvAdjustmentsCaption":
							this.invAdjustmentsLegendChartCaption = item.value;
							break;
						// Initialize info about things like lead time chart visibility.
						case "EsoDeepDiveDisplayChartFutureFC":
							this.esoDeepDiveDisplayChartFutureFCCoreSetting = item.value ? item.value.toLocaleLowerCase() : 'no';
							break;
						case "EsoDeepDiveDisplayChartLeadTime":
							this.esoDeepDiveDisplayChartLeadTimeCoreSetting = item.value ? item.value.toLocaleLowerCase() : 'no';
							break;
						case "PeriodEso":
							this.periodType = item.value ? item.value : 'Week';
							this.initializePeriodsAndSimulationData();
							break;
						// Add more cases here as needed
					}
				});


				// Check if the result is valid and has at least one entry
				if (result["esoDeepDive"]?.length > 0) {
					const firstResult = result["esoDeepDive"][0]; // Cache the first result for reuse

					// Simplify the boolean assignment with a helper method
					this.EnableTooltip = this.parseBoolean(firstResult.defaultSelectionTooltipEsoDeepDive);
					this.ShowTooltip = this.parseBoolean(firstResult.enableDisableTooltipEsoDeepDive);

					// Use nullish coalescing operator for concise assignment
					this.EsoOverviewDeepDiveDecimalPlace = parseInt(firstResult.esoOverviewDeepDiveDecimalPlace) ?? 0;
				}

				// Sequence error list items.
				if (result["sequenceErrorList"]?.length > 0) {
					this.sequenceErrorsList = result["sequenceErrorList"].map(item => item["listElement"]);
				}

			}
		});

	}

	// Helper method to parse a boolean from a string
	parseBoolean(value: string): boolean {
		return value.toLowerCase() === "yes";
	}

	// Function to handle the combined data from all API calls
	SelectObjects(productId: string): Promise<any> {
		// Call all APIs simultaneously and wait for all to complete
		// Load data for and set 3 charts - Actual Sales vs Forecast | Forecast Error | Actual Inventory.

		//MasterProductData
		this.loadMasterProductData();

		return Promise.all([this.getEsoChartData()])
			.then(results => {
				// results is an array containing the resolved values of each promise, in order
				const [EsoChartData] = results;
				this.loadProductionInfo(EsoChartData.dataForProduct);
				this.loadLeadTimeChart(EsoChartData.leadTime);
				this.loadFutureForecastChartData(EsoChartData.futureForecast);
			})
			.catch(error => {
				// If any of the API calls failed, this block is executed
				console.error('api error run :', error);
				this.leadTimeChartDatasource = [];
				this.futureForecastChartDatasource = [];
				this.loadProductionInfo([]);
				this.blankDataIfError();
			});
	}

	// Assume these are functions that return a promise for an API call
	getEsoChartData() {
		return this.esoServise.getEsoChartData(this.selectedProduct,{showLoadingIndicator:false});
	}

	getMasterProductData() {
		return this.esoServise.getMasterProductData(this.selectedProduct,{showLoadingIndicator:false});
	}

	loadProductionInfo(ProductionData) {
		try {
			this.setForecastAndActualDataChart(ProductionData);
		} catch (e) { console.error('ForecastAndActualDataChart: ', e); }
		try {
			this.setDataForecastErrorChart(ProductionData);
		} catch (e) { console.error('ForecastErrorChart: ', e); }
		try {
			this.setDataForActualInventoryChart(ProductionData);
		} catch (e) { console.error('ForActualInventoryChart: ', e); }
	}

	loadLeadTimeChart(LeadTimeChart) {
		this.leadTimeChartDatasource = LeadTimeChart;
		if (this.dxLeadTime) {
			this.dxLeadTime.instance.refresh();
		}
	}

	loadFutureForecastChartData(FutureForecast) {
		this.futureForecastChartDatasource = FutureForecast;
		if (this.dxFutureForecast) {
			this.dxFutureForecast.instance.refresh();
		}
	}

	blankDataIfError() {
		this.leadTimeChartDatasource = [];
		this.futureForecastChartDatasource = [];

		this.stockOutDataSourse = [];
		this.loadProductionInfo([]);
		this.loadMasterProductData();
		this.selectedFirstScenario = new Scenario();
		this.selectedSecondScenario = new Scenario();
	}

	loadMasterProductData() {
		Promise.all([this.getMasterProductData()])
			.then(results => {
				// results is an array containing the resolved values of each promise, in order
				const [MasterProductData] = results;
				// Do something with the results
				this.masterTableDataSource = MasterProductData.masterData;
				this.SecondHeaderName = "";
				if (MasterProductData.secondHeaderName) {
					this.SecondHeaderName = MasterProductData.secondHeaderName;
				}
			})
			.catch(error => {
				this.masterTableDataSource = [];
			});
	}

	private readonly _inventoryUnitsAsIsStorageKey = 'InventoryUnitsAsIs';
	private readonly _inventoryAmountAsIsStorageKey = 'InventoryAmountAsIs';
	private readonly _cogsAsIsStorageKey = 'CogsAsIs';
	private readonly _inventoryCapitalAsIsStorageKey = 'InventoryCapitalAsIs';
	private readonly _inventoryOpexAsIsStorageKey = 'InventoryApexAsIs';
	private readonly _stockOutAsIsStorageKey = 'StockOutAsIs';
	private readonly _unplannedProductionChangeAsIsStorageKey = 'UnplannedProductionAsIs';
	private readonly _scrapAsIsStorageKey = 'ScrapAsIs';

	private readonly _inventoryUnitsToBeStorageKey = 'InventoryUnitsToBe';
	private readonly _inventoryAmountToBeStorageKey = 'InventoryAmountToBe';
	private readonly _cogsToBeStorageKey = 'CogsToBe';
	private readonly _inventoryCapitalToBeStorageKey = 'InventoryCapitalToBe';
	private readonly _inventoryOpexToBeStorageKey = 'InventoryApexToBe';
	private readonly _stockOutToBeStorageKey = 'StockOutToBe';
	private readonly _unplannedProductionChangeToBeStorageKey = 'UnplannedProductionToBe';
	private readonly _scrapToBeStorageKey = 'ScrapToBe';

	private saveFinancialDataToSessionStorage() {
		sessionStorage.setItem(this._inventoryUnitsAsIsStorageKey, JSON.stringify(this.selectedProduct.inventoryUnitsAsIs));
		sessionStorage.setItem(this._inventoryAmountAsIsStorageKey, JSON.stringify(this.selectedProduct.inventoryAmountAsIs));
		sessionStorage.setItem(this._cogsAsIsStorageKey, JSON.stringify(this.selectedProduct.cogsAsIs));
		sessionStorage.setItem(this._inventoryCapitalAsIsStorageKey, JSON.stringify(this.selectedProduct.inventoryCapitalAsIs));
		sessionStorage.setItem(this._inventoryOpexAsIsStorageKey, JSON.stringify(this.selectedProduct.inventoryOpexAsIs));
		sessionStorage.setItem(this._stockOutAsIsStorageKey, JSON.stringify(this.selectedProduct.stockOutAsIs));
		sessionStorage.setItem(this._unplannedProductionChangeAsIsStorageKey, JSON.stringify(this.selectedProduct.unplannedProductionChangeAsIs));
		sessionStorage.setItem(this._scrapAsIsStorageKey, JSON.stringify(this.selectedProduct.scrapAsIs));

		sessionStorage.setItem(this._inventoryUnitsToBeStorageKey, JSON.stringify(this.selectedProduct.inventoryUnitsToBe));
		sessionStorage.setItem(this._inventoryAmountToBeStorageKey, JSON.stringify(this.selectedProduct.inventoryAmountToBe));
		sessionStorage.setItem(this._cogsToBeStorageKey, JSON.stringify(this.selectedProduct.cogsToBe));
		sessionStorage.setItem(this._inventoryCapitalToBeStorageKey, JSON.stringify(this.selectedProduct.inventoryCapitalToBe));
		sessionStorage.setItem(this._inventoryOpexToBeStorageKey, JSON.stringify(this.selectedProduct.inventoryOpexToBe));
		sessionStorage.setItem(this._stockOutToBeStorageKey, JSON.stringify(this.selectedProduct.stockOutToBe));
		sessionStorage.setItem(this._unplannedProductionChangeToBeStorageKey, JSON.stringify(this.selectedProduct.unplannedProductionChangeToBe));
		sessionStorage.setItem(this._scrapToBeStorageKey, JSON.stringify(this.selectedProduct.scrapToBe));
	}

	private deleteFinancialDataFromSessionStorage() {
		sessionStorage.removeItem(this._inventoryUnitsAsIsStorageKey);
		sessionStorage.removeItem(this._inventoryAmountAsIsStorageKey);
		sessionStorage.removeItem(this._cogsAsIsStorageKey);
		sessionStorage.removeItem(this._inventoryCapitalAsIsStorageKey);
		sessionStorage.removeItem(this._inventoryOpexAsIsStorageKey);
		sessionStorage.removeItem(this._stockOutAsIsStorageKey);
		sessionStorage.removeItem(this._unplannedProductionChangeAsIsStorageKey);
		sessionStorage.removeItem(this._scrapAsIsStorageKey);

		sessionStorage.removeItem(this._inventoryUnitsToBeStorageKey);
		sessionStorage.removeItem(this._inventoryAmountToBeStorageKey);
		sessionStorage.removeItem(this._cogsToBeStorageKey);
		sessionStorage.removeItem(this._inventoryCapitalToBeStorageKey);
		sessionStorage.removeItem(this._inventoryOpexToBeStorageKey);
		sessionStorage.removeItem(this._stockOutToBeStorageKey);
		sessionStorage.removeItem(this._unplannedProductionChangeToBeStorageKey);
		sessionStorage.removeItem(this._scrapToBeStorageKey);
	}
}
